import { FireAccordion } from '@nx/fire/accordion'
import { Heading } from '@nx/fire/typography'
import { getTranslate } from '@nx/translations'

import {
  StyledAccordionList,
  StyledContainer,
} from './FireAdditionalInformation.styles'
import translate from './FireAdditionalInformation.translate.json'
import { useInformation } from './useInformation'

const { text } = getTranslate(translate)

export const FireAdditionalInformation = ({
  items,
}: AdditionalInformationProps) => {
  return (
    <StyledContainer>
      <Heading as="h2" $level={4}>
        {text('title')}
      </Heading>
      <StyledAccordionList>
        <FireAccordion items={items} />
      </StyledAccordionList>
    </StyledContainer>
  )
}

export interface AdditionalInformationProps {
  items: ReturnType<typeof useInformation>
}
